module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/modules/services/components/loading/component.scss
// module id = ./src/modules/services/components/loading/component.scss
// module chunks = main